import { render, staticRenderFns } from "./KnAuthorizationGradesPerSubject.vue?vue&type=template&id=2dc7dff3"
import script from "./KnAuthorizationGradesPerSubject.js?vue&type=script&lang=js&external"
export * from "./KnAuthorizationGradesPerSubject.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports